import {
  isEmpty,
  isArray,
  forEach,
  flatMap,
  identity,
  isFunction,
  filter,
  map as mapFun,
  reject,
  reduce,
  mapValues,
  mapKeys,
  find,
} from "lodash/fp";

export const forEachIndexed = forEach.convert({ cap: false });
export const mapIndexed = mapFun.convert({ cap: false });
export const rejectIndexed = reject.convert({ cap: false });
export const reduceIndexed = reduce.convert({ cap: false });
export const filterIndexed = filter.convert({ cap: false });
export const mapValuesIndexed = mapValues.convert({ cap: false });
export const mapKeysIndexed = mapKeys.convert({ cap: false });
export const flatMapIndexed = flatMap.convert({ cap: false });
export const findIndexed = find.convert({ cap: false });

export const includeStr = (keyword) => (str) =>
  str && str.indexOf(keyword) > -1;

export const fastProp = (key) => (object) =>
  Object.prototype.toString.apply(object) !== "[object Null]" &&
  Object.prototype.toString.apply(object) !== "[object Undefined]"
    ? object[key]
    : null;

export const fastSize = (arr) =>
  arr !== null && arr !== undefined && arr.length;

export const fastEqual = (key, value) => (item) =>
  fastProp(key)(item) === value;

export const getProp = (key) => (object) => {
  if (key === undefined || key === null) {
    return undefined;
  }
  const keysArr = key.split(".");
  let index = 0;
  const length = keysArr.length;

  while (object != null && index < length) {
    // eslint-disable-next-line
    object = object[keysArr[index++]];
  }
  return object;
};

export const normalize = (arr, key = "id", transformer = identity) => {
  // eslint-disable-next-line
  const getKeyValue = isFunction(key)
    ? key
    : includeStr(".")(key)
    ? getProp(key)
    : fastProp(key);
  const obj = {};
  if (isEmpty(arr)) {
    return {};
  }
  if (!isArray(arr)) {
    return {
      [getKeyValue(arr)]: arr,
    };
  }
  const length = fastSize(arr);
  for (let i = 0; i < length; i += 1) {
    obj[getKeyValue(arr[i])] = transformer(arr[i]);
  }
  return obj;
};

// 将经纬度组装为对象
export const formatterPoint = (longitude, latitude) =>
  (longitude &&
    latitude && {
      longitude,
      latitude,
    }) ||
  null;

export function getQueryVariable (variable) {
    const index = location.href.indexOf('?');
    if (index < 0) return false;
    const query = location.href.substring(index + 1);
    const params = query.split('&');
    for (const index in params) {
        const pair = params[index].split('=');
        if (pair[0] === variable) return pair[1];
    }
    return false;
}
  // 将对像转为query字符串
// {name:'test',id:'123'}=>name=test&id=123
export function toQueryString(Obj){
  if (!Obj) {
    return ''
  }
  return Object.entries(Obj).map((arr)=>`${arr[0]}=${arr[1]}`).join('&')
}

/**判断是否是微信端 */
export function isWeChat() {
  //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  var ua = window.navigator.userAgent.toLowerCase();
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true;
  } else {
    return false;
  }
}

// 提取url中的code
export function getUrlCode() {
  const url = window.location.search
  const codeMatch = url.match(/code=([^&]*)/)
  return codeMatch ? codeMatch[1] : null
}
// 获取url中的STATE
export function getUrlState() {
  const url = window.location.search
  const stateMatch = url.match(/state=([^&]*)/)
  return stateMatch ? stateMatch[1] : null
}

// 去除字符串中的序号
/**
 * 移除字符串开头的序号前缀
 * 兼容括号/逗号/句号/顿号类序号，支持全半角、中文数字、富文本标签、拼音标签
 * @param {string} str 待处理的原始字符串
 * @returns {string} 移除序号后的字符串
 */
export function removeLeadingIndex(str) {
  if (!str || typeof str !== 'string') return str;

  // ========== 正则原子片段（统一维护，避免重复冗余） ==========
  const SPACE = '[\\s\\u3000]';               // 空白字符：含半角空白 + 全角空格
  const PREFIX_TAGS = '(?:<b>|<font\\s[^>]*>)*'; // 前缀富文本标签：加粗/字体标签
  const ARABIC_NUM = '(?:[1-9][0-9]?|[１-９][０-９]?)'; // 阿拉伯数字 1-99（半角+全角）
  const CN_NUM_CHAR = '[一二三四五六七八九十]'; // 单个中文数字
  // 中文数字 一到九十九（覆盖个位数/十几/几十/几十几）
  const CN_NUM = '(?:十[一二三四五六七八九]?|[一二三四五六七八九](?:十[一二三四五六七八九]?)?)';
  // 单个拼音标签包裹的中文数字
  const PINYIN_NUM = `<pinyin\\s[^>]*ch="${CN_NUM_CHAR}"[^>]*>\\s*<\\/pinyin>`;
  const PINYIN_CN_NUM = `(?:${PINYIN_NUM}\\s*){1,3}`; // 拼音格式中文数字（1-3个字对应一到九十九）
  const INDEX_BODY = `(?:${ARABIC_NUM}|${CN_NUM}|${PINYIN_CN_NUM})`; // 完整序号主体
  const PERIOD = '(?:[\\.。．]|<b>\\s*[\\.。．]\\s*<\\/b>)'; // 句号：半角/中文/全角，支持加粗包裹

  // ========== 匹配规则（按优先级从高到低排列，命中即返回） ==========
  const rules = [
    // 1. 小括号序号：(x) /（x）/ 括号混用，支持全半角
    new RegExp(`^${SPACE}*${PREFIX_TAGS}${SPACE}*([\\(（]${SPACE}*${INDEX_BODY}${SPACE}*[\\)）])`),
    // 2. 中括号序号：[x] /【x】/［x］/ 括号混用，支持全半角
    new RegExp(`^${SPACE}*${PREFIX_TAGS}${SPACE}*([\\[【［]${SPACE}*${INDEX_BODY}${SPACE}*[\\]】］])`),
    // 3. 逗号结尾序号：x, / x，
    new RegExp(`^${SPACE}*${PREFIX_TAGS}${SPACE}*(${INDEX_BODY}${SPACE}*[,，])`),
    // 4. 阿拉伯数字+句号：1. / ２。
    // 修复：仅当句号后直接跟数字且无分隔符时才不匹配（规避纯小数）
    new RegExp(`^${SPACE}*${PREFIX_TAGS}${SPACE}*(${ARABIC_NUM}${SPACE}*${PERIOD})`),
    // 5. 中文数字+句号：一. / 十二。
    new RegExp(`^${SPACE}*${PREFIX_TAGS}${SPACE}*((?:${CN_NUM}|${PINYIN_CN_NUM})${SPACE}*${PERIOD})`),
    // 6. 顿号结尾序号：x、
    new RegExp(`^${SPACE}*${PREFIX_TAGS}${SPACE}*(${INDEX_BODY}${SPACE}*、)`),
  ];

  // 依次匹配，命中则移除序号后返回
  for (const regex of rules) {
    const match = str.match(regex);
    if (match) {
      const toRemove = match[1];
      const index = str.indexOf(toRemove);
      if (index !== -1) {
        return str.slice(0, index) + str.slice(index + toRemove.length);
      }
    }
  }

  // 无匹配，返回原字符串
  return str;
}